import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<TournamentOptions, void>({
    query: () => ({
      url: `v4/pitch-owner/tournaments/options`,
      method: 'GET',
    }),
  });

export type TournamentOptions = {
  data: {
    sport_types: {
      id: number;
      name: string;
      name_ar: string;
      is_support_tournament: number;
    }[];
    tournament_categories: {
      id: number;
      name: string;
      name_ar: string;
      max_number_of_teams?: string;
      show_schedule?: boolean;
    }[];
    tournament_types: {
      id: number;
      name: string;
      name_ar: string;
    }[];
    rank_types: {
      id: number;
      name: string;
      name_ar: string;
    }[];
    ranks: {
      id: number;
      name: string;
      name_ar: string;
      tournament_type_id: number;
    }[];
    interface_types: {
      [key: string]: string;
    };
  };
};
